import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { widgetDataSelector } from 'app/store/selectors/dashboards';
import WidgetContainer from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/WidgetContainer/WidgetContainer';
import CostCard from 'app/pages/Project/ProductionManagement/Dashboards/Widgets/CostCard/CostCard';
const GlobalCostsWidget = ({ widget, steps }) => {
    const widgetsData = useSelector(widgetDataSelector(widget.id));
    const noSteps = steps.length === 0;
    const cardContent = () => {
        if (!widgetsData)
            return _jsx("p", { children: "No data provided" });
        if (noSteps) {
            return _jsx("p", { style: { fontSize: '20px' }, children: "No steps were set" });
        }
        const { closedCosts, totalCosts, status_counts } = widgetsData;
        return _jsx(CostCard, { statusCounts: status_counts, closedCosts: closedCosts, totalCosts: totalCosts });
    };
    return (_jsx(WidgetContainer, { widget: widget, displayError: noSteps, displayActionButton: false, children: cardContent() }));
};
export default GlobalCostsWidget;
